// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const groudon_primal: PokeData = {
  "id": 10078,
  "name": "groudon-primal",
  "height": 50,
  "weight": 9997,
  "base_experience": 347,
  "types": [
    PokeType.GROUND,
    PokeType.FIRE
  ],
  "api_moves": [
    "solar-beam",
    "earthquake",
    "fissure",
    "fire-blast",
    "rest",
    "scary-face",
    "ancient-power",
    "eruption",
    "bulk-up",
    "mud-shot",
    "hammer-arm",
    "earth-power",
    "lava-plume",
    "precipice-blades"
  ],
  "moves": [
    "solar-beam",
    "earthquake",
    "fissure",
    "scary-face",
    "ancient-power",
    "eruption",
    "bulk-up",
    "mud-shot",
    "earth-power",
    "morning-sun",
    "fire-spin",
    "flare-blitz",
    "magma-storm"
  ],
  "evolution_chain": {
    "id": 199,
    "item": null,
    "species": [
      {
        "name": "groudon",
        "order": 413,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 118,
    "speed": 94,
    "ability_power": 188
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
